/**
 * VoiceStatusIcon Component
 * Displays status icon for voice participants
 */

import React from 'react';
import { Mic, MicOff, VolumeX, Monitor } from 'lucide-react';
import type { VoiceStatus } from './voiceStatus.utils';

interface VoiceStatusIconProps {
  status: VoiceStatus;
  className?: string;
}

export const VoiceStatusIcon: React.FC<VoiceStatusIconProps> = ({ status, className }) => {
  const baseClasses = 'w-3.5 h-3.5';

  switch (status) {
    case 'speaking':
      return <Mic className={`${baseClasses} text-green-400 ${className || ''}`} data-icon="mic" />;
    case 'muted':
      return <MicOff className={`${baseClasses} text-red-400 ${className || ''}`} data-icon="mic-off" />;
    case 'deafened':
      return <VolumeX className={`${baseClasses} text-gray-500 ${className || ''}`} data-icon="volume-x" />;
    case 'screen_sharing':
      return <Monitor className={`${baseClasses} text-blue-400 ${className || ''}`} data-icon="monitor" />;
    case 'active':
      return <Mic className={`${baseClasses} text-gray-400 ${className || ''}`} data-icon="mic" />;
  }
};
